/**
 * @file 多业务线公用中转
 */

// 订单保障
const orderSecurity = resolve =>
  import(
    /* webpackChunkName: "reporting-center" */ '../views/transit-page/order-security/index.vue'
  );

// 保障金额
const securityLimit = resolve =>
  import(
  /* webpackChunkName: "reporting-center" */ '../views/transit-page/order-security/security-limit.vue'
  );

// 赠险保障须知
const clause = resolve =>
  import(
  /* webpackChunkName: "reporting-center" */ '../views/transit-page/order-security/clause.vue'
  );

// 保障金申请方式
const securityLimitApply = resolve =>
  import(
    /* webpackChunkName: "reporting-center" */ '../views/transit-page/order-security/security-limit-apply.vue'
  );

// 货拉拉平台用户货物保障条款
const cargoDamage = resolve =>
  import(
  /* webpackChunkName: "reporting-center" */ '../views/transit-page/order-security/cargo-damage.vue'
  );

export default [
  {
    name: 'transitPageOrderSecurity',
    path: '/transit-page/order-security',
    component: orderSecurity,
    meta: { title: '订单保障' },
  },
  {
    name: 'transitPageSecurityLimit',
    path: '/transit-page/security-limit',
    component: securityLimit,
    meta: { title: '保障金额' },
  },
  {
    name: 'transitPageClause',
    path: '/transit-page/clause',
    component: clause,
    meta: { title: '赠险保障须知' },
  },
  {
    name: 'transitPageSecurityLimitApply',
    path: '/transit-page/security-limit-apply',
    component: securityLimitApply,
    meta: { title: '保障金申请方式（规则）' },
  },
  {
    name: 'transitPageSecurityCargoDamage',
    path: '/transit-page/cargo-damage',
    component: cargoDamage,
    meta: { title: '货拉拉平台用户货物保障条款' },
  },
];
